<template>
  <v-app style="background-color:#eeeeee">
    

     <div style="padding-top:150px">
           <v-card flat class="banner" style="border-radius:0px">
               <h1 style="color:white;padding-top:100px;font-size:50px">{{itemList.length}}+ Enquiries</h1>
               <h5 style="color:white;"></h5>
           </v-card>
          <v-container>
           <v-layout row wrap>
               <v-flex xs12 sm12 md3 v-for="(item, index) in itemList" :key="item.id" style="padding:5px">
                   <v-card class="txt_dec" flat style="border-radius:0px;background-color:#e53935;cursor:pointer" v-if="(index + 1)%2 != 0" @click="enquiry(item)">
              <v-card-title style="padding:0px">
                <v-sheet color="transparent" style="padding-top:0px">
                            <v-avatar :size="70" style="background-color:#d1ffe1">
                                <img src="https://www.eliterestaurantequipment.com/media_cache//media/images/catalog/category/categorylisting/urcdsmall-8_b148d5caaf3bf4127d3c6c7d9c3034c0.jpg" />
                        </v-avatar>
                        </v-sheet>
                        <v-spacer></v-spacer>
                        <h6 style="color:white;text-align:right;">
                          <span style="font-weight:bold">Enquiry ID :&nbsp;{{item.code}}</span><br/>
                        <!-- <span class="recent">Category : Refrigerated</span> --><br/>
                        <span class="recent">Enquiry Date :&nbsp;{{item.date}}</span><br/>
                        <span class="recent">Quantity : <span style="font-weight:bold;font-size:25px">{{item.quantity}}</span></span></h6> 
              </v-card-title>
          </v-card>

          <v-card class="txt_dec" flat style="border-radius:0px;background-color:#212121;cursor:pointer" v-if="(index + 1)%2 == 0" @click="enquiry(item)">
              <v-card-title style="padding:0px">
                <v-sheet color="transparent" style="padding-top:0px">
                            <v-avatar :size="70" style="background-color:#d1ffe1">
                                <img src="https://www.eliterestaurantequipment.com/media_cache//media/images/catalog/category/categorylisting/urcdsmall-8_b148d5caaf3bf4127d3c6c7d9c3034c0.jpg" />
                        </v-avatar>
                        </v-sheet>
                        <v-spacer></v-spacer>
                        <h6 style="color:white;text-align:right;">
                          <span style="font-weight:bold">Enquiry ID :&nbsp;{{item.code}}</span><br/>
                        <!-- <span class="recent">Category : Refrigerated</span> --><br/>
                        <span class="recent">Enquiry Date :&nbsp;{{item.date}}</span><br/>
                        <span class="recent">Quantity : <span style="font-weight:bold;font-size:25px">{{item.quantity}}</span></span></h6> 
              </v-card-title>
          </v-card>
               </v-flex>
           </v-layout>
           </v-container>
     </div>

     
  </v-app>
</template>

<script>
import config from "./../../config.json";
import carousel from 'vue-owl-carousel';
//import VueEasyLightbox from 'vue-easy-lightbox';
import GoTop from '@inotom/vue-go-top';

export default {
  components: {
    GoTop,
    carousel,
  },
  data() {
    return {
      valid: true,
      form: {
        tourPackage: null,
        destination: null
      },

      id: sessionStorage.id,
      itemList: [],
    };
  },
  
   mounted() {
     this.getData();
   },

 methods: {
     getData() {
         this.axios
        .get(config.API + "EnquiryList", {
          headers: {
            Authorization: "bearer " + sessionStorage.getItem("token")
          }
        })
        .then(res => {
          this.itemList = res.data;
          console.log(this.itemList);
          this.$Progress.finish();
        })
        .catch(err => {
          this.$Progress.fail();
        });
     },
     
     enquiry(item) {
     this.$router.push(`/enquiryDetail/` + item.id);
   }
 }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Nanum+Gothic&display=swap');
@import url('https://fonts.googleapis.com/css?family=Montserrat|Space+Mono&display=swap');
@import url('https://fonts.googleapis.com/css?family=Anton&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Lexend+Tera&family=Open+Sans:wght@600&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Metal+Mania&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Bebas+Neue&family=Patua+One&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Galada&family=Modak&family=Roboto&family=Roboto+Mono:ital,wght@1,600&display=swap');
</style>

<style scoped>
.banner {
  background-image: url('https://static.vecteezy.com/system/resources/previews/001/052/058/non_2x/abstract-red-paint-brushstroke-banner-vector.jpg');
  background-size: cover;

  height:300px;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 2px solid;
  border-color: black !important;
}
.hvr1:hover {
  cursor: pointer;
  text-decoration: underline;
  color: #2196f3;
}
.v-card {
  padding: 10px;
  border-radius: 8px;
}
.v-sheet--offsets {
  top: -50px;
  position: relative;
}
.v-sheet--offset {
  top: -30px;
  position: relative;
}
.v-sheet--offsetf {
  top: -100px;
  position: relative;
}
.swo {
  box-shadow: none !important;
}
.opa {
  opacity: 1;
}
.tourtheme {
  height: 180px;
  margin: 5px;
  background-size: cover;
}
.themecap {
  font-family: 'Open Sans', sans-serif;
  padding-top: 130px;
  color: white;
}
.top-left {
  font-family: 'Roboto Mono', monospace;
  font-size:40px ;
  padding-top: 200px;
  color: white;
  text-align: center;
}
.salont {
  font-family: 'Patua One', cursive;
}
.hvr:hover {
  cursor: pointer;
  /* height: 200px; */
  border : 3px solid;
  border-color: white;
}
.v-table tbody tr:not(:last-child) {
    border-bottom: none !important;
}
@media screen and (max-width: 768px) {
  .res {
    display: none;
  }
}
@media screen and (min-width: 768px){
  .man {
    display: none;
  }
}
img.center {
    display: block;
    margin: 0 auto;
}
.recent {
  font-family: 'Nanum Gothic', sans-serif;
}
.srch {
  position: absolute;
  z-index: 10;
  left: 16%;
  top: 0%;
}
.item {
    border:1px solid !important;
}
</style>
